import { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ReactNode;
}

function PageHeader({ title, description, actions }: PageHeaderProps) {
  return (
    <header className={ClassName.container}>
      <div className={ClassName.copy}>
        <h1 className={ClassName.title}>{title}</h1>
        {description ? (
          <p className={ClassName.description}>{description}</p>
        ) : null}
      </div>
      {actions ? <div className={ClassName.actions}>{actions}</div> : null}
    </header>
  );
}

export default PageHeader;

const ClassName = {
  container:
    "flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between",
  copy: "min-w-0",
  title: "text-2xl font-bold tracking-tight text-primaryText",
  description: "mt-1 max-w-2xl text-sm leading-5 text-secondaryText",
  actions: "flex shrink-0 flex-wrap items-center gap-2",
};
